import { API } from "../auth/authApi";

export const getMediaApi = (params) => {
  return API.get("/media", { params });
};

export const createMediaApi = (data) => {
  return API.post("/media", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const updateMediaApi = (id, data) => {
  return API.put(`/media/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteMediaApi = (id) => {
  return API.delete(`/media/${id}`);
};